module.exports = __webpack_public_path__ + "img/leaf_left.3607a943.png";